import clsx from 'clsx';
import React from 'react';

import { ValidationStatus } from '@/api/lib/restaurant';

export interface Props {
  status?: ValidationStatus;
  circleOnly?: boolean;
}

const statusStyles = {
  ACCEPTED: {
    circle: 'bg-emerald-500 border border-emerald-600/30 ring-4 ring-emerald-300/80',
    text: 'bg-emerald-500 text-white border border-emerald-600',
    label: 'Active'
  },
  PENDING: {
    circle: 'bg-yellow-400 border border-yellow-500/30 ring-4 ring-yellow-200/80',
    text: 'bg-yellow-400 text-white border border-yellow-500',
    label: 'En attente'
  },
  REJECTED: {
    circle: 'bg-red-400 border border-red-500/30 ring-4 ring-red-200/80',
    text: 'bg-red-400 text-white border border-red-500',
    label: 'Refusé'
  }
};

export const RestaurantStatus: React.FC<Props> = ({ status = 'ACCEPTED', circleOnly }) => {
  if (status !== 'PENDING' && status !== 'REJECTED' && status !== 'ACCEPTED') {
    status = 'PENDING';
  }
  const currentStyles = statusStyles[status];

  return (
    <>
      {circleOnly ? (
        <div className={clsx(currentStyles.circle, 'w-3 h-3 rounded-full')} />
      ) : (
        <div className={clsx(currentStyles.text, 'px-4 py-1 w-fit text-xs rounded-full')}>{currentStyles.label}</div>
      )}
    </>
  );
};
